import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: function () { 
        return import('./views/Home.vue')
      }
    },
    {
      path: '/about',
      name: 'about',
      component: function () { 
        return import('./views/About.vue')
      }
    },
    {
      path: '/car',
      name: 'car',
      component: function () { 
        return import('./views/Car.vue')
      }
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: function () { 
        return import('./views/Recruit.vue')
      }
    },
    {
      path: '/join',
      name: 'join',
      component: function () { 
        return import('./views/Join.vue')
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: function () { 
        return import('./views/Contact.vue')
      }
    },
    {
      path: '/login',
      name: 'login',
      component: function () { 
        return import('./views/login.vue')
      }
    },
  ]
})
